export default {
  "chartOption.pluginName": "插件名",
  "chartOption.animationDuration": "动画持续时间",
  "chartOption.refreshTime": "动画刷新间隔",
  updateTimer: "数据源轮询时间",
  restDataUrl: "外接数据源地址"
}
